export default __webpack_public_path__ + "static/media/Roboto-Bold.63311334.ttf";